import { loginReq } from "@/api/services/auth";
import type { JWTUser } from "@/pages/Login/store";
import type { LoginFormData } from "@/pages/Login/store/types";
import { AxiosError } from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { authStore } from "@/pages/Login/store";

// Helper to store tokens and update auth state (used after signup/reset)
export const login = (token: string, refreshToken: string): JWTUser => {
  const user = jwtDecode<JWTUser>(token);
  Cookies.set("token", token);
  Cookies.set("refresh-token", refreshToken);
  authStore.getState().setLogin(user);
  return user;
};

export const loginHandler = async (
  data: LoginFormData
): Promise<
  { data: JWTUser; errorMessage: null } | { data: null; errorMessage: string }
> => {
  try {
    const response = await loginReq(data);

    if (response.status === 201 && response.data) {
      const { token, refreshToken } = response.data;

      // decode user and update store
      const user = jwtDecode<JWTUser>(token);

      // persist tokens
      Cookies.set("token", token);
      Cookies.set("refresh-token", refreshToken);
      return { data: user, errorMessage: null };
    }

    if (response.status === 400) {
      return { data: null, errorMessage: "User not found" };
    } else if (response.status === 401) {
      return { data: null, errorMessage: "Invalid credentials" };
    } else {
      return { data: null, errorMessage: "Unexpected response from server" };
    }
  } catch (err: unknown) {
    if (err instanceof AxiosError) {
      const message =
        err.response?.data?.message ||
        err.message ||
        "Something went wrong during login";

      return { data: null, errorMessage: message };
    } else {
      return { data: null, errorMessage: "Something went wrong during login" };
    }
  }
};
